import * as React from 'react';
import { IS_NODE_SERVER } from '../constants/config';

import { isIOS } from '../utils/device';
import { StorableDataKeys, LocalStorage } from '@weddingspot/ws-core-components';
import { useLocation } from 'react-router-dom';

const iosAppIcon = require('../assets/images/icons/ios-app-icon-sm.png');

let storage: false | typeof LocalStorage = false;

if (!IS_NODE_SERVER) {
    storage = LocalStorage;
}

const IosAppBannerContainer = () => {
    const [showBanner, setShowBanner] = React.useState(false);
    const location = useLocation();

    React.useEffect(() => {
        if (isIOS() && storage) {
            const bannerLastDismissed = storage.getItem(StorableDataKeys.WS_APP_BANNER_LAST_DISMISSED);
            if (bannerLastDismissed) {
                const now: number = new Date().getTime() / 1000;
                const bannerSeconds = parseInt(bannerLastDismissed, 10);
                if (now - bannerSeconds > 36 * 100 * 24 * 7) {
                    setShowBanner(true);
                }
            } else {
                setShowBanner(true);
            }
        }
    }, []);

    const saveClickDate = () => {
        if (storage) {
            storage.setItem(StorableDataKeys.WS_APP_BANNER_LAST_DISMISSED, '' + new Date().getTime() / 1000);
            setShowBanner(false);
        }
    };

    if (!showBanner || location.pathname.match('/hotels/')) {
        return null;
    }

    return (
        <div className={'IosAppBanner' + (showBanner ? '' : ' IosAppBanner__hidden')}>
            <a href='https://itunes.apple.com/us/app/wedding-spot/id1039250968' className='IosAppBanner--button Button Button-sm'>
                Download
            </a>
            <a href='https://itunes.apple.com/us/app/wedding-spot/id1039250968' className='IosAppBanner--app-link'>
                <img src={iosAppIcon} />
            </a>

            <div className='IosAppBanner--teaser'>
                <h3 className='IosAppBanner--headline'>Wedding Spot for iOS</h3>
                <div className='IosAppBanner--stars-wrapper'>
                    <i className='IosAppBanner--star icon-hb-nx-star-filled' />
                    <i className='IosAppBanner--star icon-hb-nx-star-filled' />
                    <i className='IosAppBanner--star icon-hb-nx-star-filled' />
                    <i className='IosAppBanner--star icon-hb-nx-star-filled' />
                    <i className='IosAppBanner--star icon-hb-nx-star-filled is-half' />
                    <span className='IosAppBanner--reviews'> 4.7 </span>
                </div>
            </div>

            <a
                href='#'
                className='IosAppBanner--close-link'
                onClick={(e) => {
                    e.preventDefault();
                    saveClickDate();
                }}
            >
                ×
            </a>
        </div>
    );
};

export default IosAppBannerContainer;
